var AnalyticsTrackingEvent = /* @__PURE__ */ ((AnalyticsTrackingEvent2) => {
  AnalyticsTrackingEvent2["OPEN_APP"] = "app open";
  AnalyticsTrackingEvent2["FINGERPRINTJS_ERROR"] = "fingerprintjs_error";
  AnalyticsTrackingEvent2["GRAPHQL_ERROR"] = "graphql_error";
  AnalyticsTrackingEvent2["BRANDCLUB_LANDING_PAGE_LOADED"] = "brandclub_landing_page_loaded";
  AnalyticsTrackingEvent2["BRANDCLUB_LANDING_PAGE_TEXT_APP_LINK"] = "brandclub_landing_page_text_app_link";
  AnalyticsTrackingEvent2["BRANDCLUB_LANDING_PAGE_QRCODE_SCANNED"] = "brandclub_landing_page_qrcode_scanned";
  AnalyticsTrackingEvent2["JOINED_BRANDCLUB"] = "joined brandclub";
  AnalyticsTrackingEvent2["OPENED_SHARE_AFFILIATE_LINK"] = "Opened share affiliate link";
  AnalyticsTrackingEvent2["OPENED_SHARE_REFERRAL_CODE"] = "Opened share referral code";
  AnalyticsTrackingEvent2["OPENED_SHARE_PAGE_CARD_LINK"] = "Opened share page card link";
  AnalyticsTrackingEvent2["CLOSED_SHARE_AFFILIATE_LINK"] = "Closed share affiliate link";
  AnalyticsTrackingEvent2["CLOSED_SHARE_REFERRAL_CODE"] = "Closed share referral code";
  AnalyticsTrackingEvent2["CLOSED_SHARE_PAGE_CARD_LINK"] = "Closed share page card link";
  AnalyticsTrackingEvent2["SHARED_AFFILIATE_LINK"] = "Shared affiliate link";
  AnalyticsTrackingEvent2["SHARED_REFERRAL_CODE"] = "Shared referral code";
  AnalyticsTrackingEvent2["SHARED_PAGE_CARD_LINK"] = "Shared page card link";
  AnalyticsTrackingEvent2["TEST_EVENT"] = "test event";
  AnalyticsTrackingEvent2["MESSAGE_DETAIL_PAGE_OPENED"] = "messageDetailPage opened";
  AnalyticsTrackingEvent2["MESSAGE_DETAIL_PAGE_LINK_CLICKED"] = "messageDetailPage link clicked";
  AnalyticsTrackingEvent2["SELECTED_SEARCH_TERM_FROM_DROPDOWN"] = "selected search term from dropdown";
  AnalyticsTrackingEvent2["SERVER_SIDE_SYNC_MFA_CHOOSE_OPEN"] = "server_side_sync_mfa_choose_open";
  AnalyticsTrackingEvent2["SERVER_SIDE_SYNC_MFA_CHOOSE_SUCCESS"] = "server_side_sync_mfa_choose_success";
  AnalyticsTrackingEvent2["SERVER_SIDE_SYNC_MFA_CHOOSE_ERROR"] = "server_side_sync_mfa_choose_error";
  AnalyticsTrackingEvent2["SERVER_SIDE_SYNC_MFA_ENTER_OPEN"] = "server_side_sync_mfa_enter_open";
  AnalyticsTrackingEvent2["SERVER_SIDE_SYNC_MFA_ENTER_SUCCESS"] = "server_side_sync_mfa_enter_success";
  AnalyticsTrackingEvent2["SERVER_SIDE_SYNC_MFA_ENTER_ERROR"] = "server_side_sync_mfa_enter_error";
  AnalyticsTrackingEvent2["SERVER_SIDE_SYNC_MFA_TEXT_MESSAGE_ENTER_SUCCESS"] = "server_side_sync_mfa_text_message_enter_success";
  AnalyticsTrackingEvent2["SERVER_SIDE_SYNC_MFA_TEXT_MESSAGE_CHOOSE_SUCCESS"] = "server_side_sync_mfa_text_message_choose_success";
  AnalyticsTrackingEvent2["SAVE_REVIEW"] = "save review";
  AnalyticsTrackingEvent2["INVALID_REVIEW"] = "invalid review";
  AnalyticsTrackingEvent2["SAVE_REVIEW_SUCCESS"] = "save review success";
  AnalyticsTrackingEvent2["ERROR_WHILE_SAVING_REVIEW"] = "error while saving review";
  AnalyticsTrackingEvent2["BACK_REVIEW"] = "back_review";
  AnalyticsTrackingEvent2["STARTED_SUBMIT_REVIEW"] = "started submit review";
  AnalyticsTrackingEvent2["SENDING_NON_ELIGIBLE_REVIEW_TO_BRAND"] = "Sending non-eligible review to brand";
  AnalyticsTrackingEvent2["SELECTED_APP_REVIEW_OPTION"] = "selected app review option";
  AnalyticsTrackingEvent2["SKIPPED_LEAVE_APP_REVIEW"] = "skipped leave app review";
  AnalyticsTrackingEvent2["CONTINUE_REVIEW"] = "continue_review";
  AnalyticsTrackingEvent2["STARTED_SCANNING"] = "Started scanning";
  AnalyticsTrackingEvent2["ERROR_WHILE_SCANNING"] = "Error while scanning";
  AnalyticsTrackingEvent2["COMPLETED_SCANNING"] = "Completed scanning";
  AnalyticsTrackingEvent2["RETAILER_SYNC_STARTED"] = "retailer_sync_started";
  AnalyticsTrackingEvent2["RETAILER_SYNC_COMPLETED"] = "retailer_sync_completed";
  AnalyticsTrackingEvent2["DISCONNECT_RETAILER"] = "disconnect_retailer";
  AnalyticsTrackingEvent2["MOBILE_APP_SOCIAL_LINK_OPEN_PRODUCT_PAGE"] = "mobileApp:socialLink:openProductPage";
  AnalyticsTrackingEvent2["MOBILE_APP_SOCIAL_LINK_PRODUCT_NOT_FOUND"] = "mobileApp:socialLink:productNotFound";
  AnalyticsTrackingEvent2["MOBILE_APP_SOCIAL_LINK_CLOSE_RETAILER_PRODUCT_PAGE"] = "mobileApp:socialLink:closeRetailerProductPage";
  AnalyticsTrackingEvent2["MOBILE_APP_ORGANIC_OPEN_PRODUCT_PAGE"] = "mobileApp:organic:openProductPage";
  AnalyticsTrackingEvent2["MOBILE_APP_ORGANIC_PRODUCT_NOT_FOUND"] = "mobileApp:organic:productNotFound";
  AnalyticsTrackingEvent2["MOBILE_APP_ORGANIC_CLOSE_RETAILER_PRODUCT_PAGE"] = "mobileApp:organic:closeRetailerProductPage";
  AnalyticsTrackingEvent2["MOBILE_APP_PRODUCT_PAGE_SCROLL"] = "mobileApp:productPage:scroll";
  AnalyticsTrackingEvent2["WEB_APP_SOCIAL_LINK_TEXT_APP_DOWNLOAD_LINK"] = "webApp:socialLink:textAppDownloadLink";
  AnalyticsTrackingEvent2["WEB_APP_ORGANIC_ADD_TO_CART"] = "webApp:organic:addToCart";
  AnalyticsTrackingEvent2["OPEN_RETAILER_PRODUCT_PAGE"] = "openRetailerProductPage";
  AnalyticsTrackingEvent2["WEB_APP_ORGANIC_OPEN_VIEW_OFFERS"] = "webApp:organic:openViewOffers";
  AnalyticsTrackingEvent2["WEB_APP_ORGANIC_OPEN_RETAILER_PRODUCT_PAGE"] = "webApp:organic:openRetailerProductPage";
  AnalyticsTrackingEvent2["WEB_APP_PRODUCT_PAGE_SCROLL"] = "webApp:productPage:scroll";
  AnalyticsTrackingEvent2["ACCOUNTS_HOME_RETAILERS"] = "accounts_home_retailers";
  AnalyticsTrackingEvent2["AUTO_SIGN_IN"] = "auto sign in";
  AnalyticsTrackingEvent2["ERROR_ON_NEXT_IN_SIGN_UP"] = "error on next in sign up";
  AnalyticsTrackingEvent2["OPENED_TERMS_OF_SERVICE"] = "opened terms of service";
  AnalyticsTrackingEvent2["OPENED_PRIVACY_POLICY"] = "opened privacy policy";
  AnalyticsTrackingEvent2["SIGN_UP"] = "sign up";
  AnalyticsTrackingEvent2["SIGN_IN"] = "sign in";
  AnalyticsTrackingEvent2["SIGN_OUT"] = "sign out";
  AnalyticsTrackingEvent2["SIGN_IN_FAILURE"] = "sign in failure";
  AnalyticsTrackingEvent2["COMPLETED_ONBOARDING"] = "completed_onboarding";
  AnalyticsTrackingEvent2["VERIFIED_PHONE_NUMBER"] = "verified phone number";
  AnalyticsTrackingEvent2["RESEND_PHONE_VERIFICATION"] = "resend phone verification";
  AnalyticsTrackingEvent2["ERROR_VERIFYING_PHONE_VERIFICATION_CODE"] = "error verifying phone verification code";
  AnalyticsTrackingEvent2["PASSWORD_RESET_ATTEMPTS"] = "password reset attempts";
  AnalyticsTrackingEvent2["PASSWORD_RESET_SUCCESSFUL"] = "password reset successful";
  AnalyticsTrackingEvent2["SELECTED_SIGN_UP_WITH_EMAIL"] = "selected sign up with email";
  AnalyticsTrackingEvent2["SELECTED_FEDERATED_SIGN_IN"] = "selected federated sign in";
  AnalyticsTrackingEvent2["LOGIN_SCREEN_VISITS"] = "login screen visits";
  AnalyticsTrackingEvent2["BC_CHECKOUT_OPEN_BAG_PAGE"] = "bc_checkout_open_bag_page";
  AnalyticsTrackingEvent2["WEBVIEW_WHITE_SCREEN"] = "webview white screen";
  AnalyticsTrackingEvent2["BRANDCLUB_SEARCH_TERM"] = "brandclubSearchTerm";
  AnalyticsTrackingEvent2["STARTED_TUTORIAL"] = "started tutorial";
  AnalyticsTrackingEvent2["COMPLETED_TUTORIAL"] = "completed tutorial";
  AnalyticsTrackingEvent2["DAILY_DEALS_PRODUCT_CARD_CLICK"] = "Daily deals product card click";
  AnalyticsTrackingEvent2["START_SURVEY"] = "start_survey";
  AnalyticsTrackingEvent2["SURVEY_FAILED"] = "survey failed";
  AnalyticsTrackingEvent2["SURVEY_RESTART"] = "survey restart";
  AnalyticsTrackingEvent2["SURVEY_CANCEL"] = "survey cancel";
  AnalyticsTrackingEvent2["COMPLETED_SURVEY"] = "completed survey";
  AnalyticsTrackingEvent2["BACK_SURVEY"] = "back_survey";
  AnalyticsTrackingEvent2["SELECTED_SURVEY_OPTION"] = "selected_survey_option";
  AnalyticsTrackingEvent2["START_CONTENT"] = "start_content";
  AnalyticsTrackingEvent2["RESTART_CONTENT"] = "restart_content";
  AnalyticsTrackingEvent2["CANCEL_CONTENT"] = "cancel_content";
  AnalyticsTrackingEvent2["BACK_CONTENT"] = "back_content";
  AnalyticsTrackingEvent2["CONTINUE_CONTENT"] = "continue_content";
  AnalyticsTrackingEvent2["FAILED_CONTENT"] = "failed_content";
  AnalyticsTrackingEvent2["COMPLETED_CONTENT"] = "completed_content";
  AnalyticsTrackingEvent2["CASH_OUT_REQUESTED"] = "cash out requested";
  AnalyticsTrackingEvent2["CASH_OUT_SUCCESS"] = "cash out success";
  AnalyticsTrackingEvent2["CASH_OUT_FAILED"] = "cash out failed";
  AnalyticsTrackingEvent2["EMPTY_CASH_OUT"] = "empty_cash_out";
  AnalyticsTrackingEvent2["SYNC_SUMMARY_NOTIFICATION"] = "Sync Summary Notification";
  AnalyticsTrackingEvent2["SEARCH"] = "search";
  AnalyticsTrackingEvent2["NO_SEARCH_RESULTS"] = "no search results";
  AnalyticsTrackingEvent2["SEARCH_ERROR"] = "Search error";
  AnalyticsTrackingEvent2["DEEPLINK_OPEN_SUCCESS"] = "deeplink open success";
  AnalyticsTrackingEvent2["DEEPLINK_OPEN_ERROR"] = "deeplink open error";
  AnalyticsTrackingEvent2["NOTIFICATION_OPEN_SUCCESS"] = "notification open success";
  AnalyticsTrackingEvent2["NOTIFICATION_OPEN_ERROR"] = "notification open error";
  AnalyticsTrackingEvent2["NOTIFICATION_USER_RESPONDED"] = "notification user responded";
  AnalyticsTrackingEvent2["OPENED_APP_LINK"] = "opened app link";
  AnalyticsTrackingEvent2["ERROR_OPENING_APP_LINK"] = "error opening app link";
  AnalyticsTrackingEvent2["ERROR_OPENING_BRANCH_APP_LINK"] = "error opening branch app link";
  AnalyticsTrackingEvent2["ERROR_PAGE"] = "error page";
  AnalyticsTrackingEvent2["WARNING"] = "warning";
  AnalyticsTrackingEvent2["ERROR"] = "error";
  AnalyticsTrackingEvent2["RETURN_PANIC"] = "return panic";
  AnalyticsTrackingEvent2["TOMBSTONE"] = "tombstone: ";
  AnalyticsTrackingEvent2["INITIATE_CHECKOUT"] = "initiate_checkout";
  AnalyticsTrackingEvent2["BAG_BUTTON_CLICKED"] = "bag_button_clicked";
  AnalyticsTrackingEvent2["VIEW_BAG"] = "view_bag";
  AnalyticsTrackingEvent2["EMPTY_BAG"] = "empty_bag";
  AnalyticsTrackingEvent2["BAG_FULL"] = "bag_full";
  AnalyticsTrackingEvent2["UPDATE_BAG_QUANTITY"] = "update_bag_quantity";
  AnalyticsTrackingEvent2["CLOSE_CHECKOUT_ERROR"] = "close_checkout_error";
  AnalyticsTrackingEvent2["CHECKOUT_ERROR"] = "checkout_error";
  AnalyticsTrackingEvent2["CHECKOUT_NEXT_RETAILER"] = "checkout_next_retailer";
  AnalyticsTrackingEvent2["SKIP_CHECKOUT"] = "skip_checkout";
  AnalyticsTrackingEvent2["VIEW_CHECKOUT_SUMMARY"] = "view_checkout_summary";
  AnalyticsTrackingEvent2["REMOVE_CHECKOUT_OUT_OF_STOCK"] = "remove_checkout_out_of_stock";
  AnalyticsTrackingEvent2["CONFIRM_CHECKOUT_PARTIAL_OUT_OF_STOCK"] = "confirm_checkout_partial_out_of_stock";
  AnalyticsTrackingEvent2["ALL_OUT_OF_STOCK"] = "all_out_of_stock";
  AnalyticsTrackingEvent2["ADD_PAYMENT_METHOD"] = "add_payment_method";
  AnalyticsTrackingEvent2["DELETE_PAYMENT_METHOD"] = "delete_payment_method";
  AnalyticsTrackingEvent2["UPDATE_PAYMENT_METHOD"] = "update_payment_method";
  AnalyticsTrackingEvent2["CANCEL_UPDATE_PAYMENT_METHOD"] = "cancel_update_payment_method";
  AnalyticsTrackingEvent2["SAVE_UPDATE_PAYMENT_METHOD"] = "save_update_payment_method";
  AnalyticsTrackingEvent2["ADD_ADDRESS"] = "add_address";
  AnalyticsTrackingEvent2["DELETE_ADDRESS"] = "delete_address";
  AnalyticsTrackingEvent2["UPDATE_ADDRESS"] = "update_address";
  AnalyticsTrackingEvent2["CANCEL_UPDATE_ADDRESS"] = "cancel_update_address";
  AnalyticsTrackingEvent2["SAVE_UPDATE_ADDRESS"] = "save_update_address";
  AnalyticsTrackingEvent2["UPDATE_SECURITY"] = "update_security";
  AnalyticsTrackingEvent2["CANCEL_UPDATE_SECURITY"] = "cancel_update_security";
  AnalyticsTrackingEvent2["SAVE_UPDATE_SECURITY"] = "save_update_security";
  AnalyticsTrackingEvent2["CANCEL_UPDATE_PROFILE"] = "cancel_update_profile";
  AnalyticsTrackingEvent2["SAVE_UPDATE_PROFILE"] = "save_update_profile";
  AnalyticsTrackingEvent2["BUY_AGAIN"] = "buy_again";
  AnalyticsTrackingEvent2["TRACK_PACKAGE"] = "track_package";
  AnalyticsTrackingEvent2["VIEW_PURCHASE"] = "view_purchase";
  AnalyticsTrackingEvent2["VIEW_PRODUCT"] = "view_product";
  AnalyticsTrackingEvent2["EMPTY_PURCHASES"] = "empty_purchases";
  AnalyticsTrackingEvent2["EMPTY_REWARDS"] = "empty_rewards";
  AnalyticsTrackingEvent2["GET_APP"] = "get_app";
  AnalyticsTrackingEvent2["REWARD_INFO"] = "reward_info";
  AnalyticsTrackingEvent2["CLOSE_HOME_MENU"] = "close_home_menu";
  AnalyticsTrackingEvent2["LANDING_PAGE_VIDEO_PLAY_STARTED"] = "landingPage:videoPlayStarted";
  AnalyticsTrackingEvent2["LANDING_PAGE_VIDEO_PLAY_PAUSED"] = "landingPage:videoPlayPaused";
  AnalyticsTrackingEvent2["LANDING_PAGE_VIDEO_PLAY_ENDED"] = "landingPage:videoPlayEnded";
  AnalyticsTrackingEvent2["PAGE_VIEW"] = "page view";
  AnalyticsTrackingEvent2["BC_USER_REQUESTED_CHECKOUT"] = "bc_user_requested_checkout";
  AnalyticsTrackingEvent2["BC_USER_ADDED_TO_BAG_FROM_URL"] = "bc_user_added_to_bag_from_url";
  AnalyticsTrackingEvent2["CHECKOUT_INTENT_CREATED"] = "bc_checkout_intent_created";
  AnalyticsTrackingEvent2["CHECKOUT_PAGE_VIEW"] = "bc_checkout_page_view";
  AnalyticsTrackingEvent2["CHECKOUT_STEP_VIEWED"] = "bc_checkout_step_viewed";
  AnalyticsTrackingEvent2["CHECKOUT_STEP_COMPLETED"] = "bc_checkout_step_completed";
  AnalyticsTrackingEvent2["CHECKOUT_STEP_ERROR"] = "bc_checkout_step_error";
  AnalyticsTrackingEvent2["CHECKOUT_RETAILER_FORGOT_PASSWORD_CLICK"] = "bc_checkout_retailer_forgot_password_click";
  AnalyticsTrackingEvent2["CHECKOUT_PAYMENT_ADD"] = "bc_checkout_payment_add";
  AnalyticsTrackingEvent2["CHECKOUT_PAYMENT_SELECT"] = "bc_checkout_payment_select";
  AnalyticsTrackingEvent2["CHECKOUT_ORDER_SUBMIT"] = "bc_checkout_order_submit";
  AnalyticsTrackingEvent2["CHECKOUT_ORDER_SUCCESS"] = "bc_checkout_order_success";
  AnalyticsTrackingEvent2["CHECKOUT_ORDER_FAILURE"] = "bc_checkout_order_failure";
  AnalyticsTrackingEvent2["CHECKOUT_GUEST_ORDER_SUBMIT"] = "bc_checkout_guest_order_submit";
  AnalyticsTrackingEvent2["CHECKOUT_SIGN_IN_PHONE_SUBMIT"] = "bc_checkout_sign_in_phone_submit";
  AnalyticsTrackingEvent2["CHECKOUT_SIGN_IN_OTP_POPUP_OPEN"] = "bc_checkout_sign_in_otp_popup_open";
  AnalyticsTrackingEvent2["CHECKOUT_SIGN_IN_OTP_SUBMIT"] = "bc_checkout_sign_in_otp_submit";
  AnalyticsTrackingEvent2["CHECKOUT_SIGN_IN_OTP_RESEND"] = "bc_checkout_sign_in_otp_resend";
  AnalyticsTrackingEvent2["CHECKOUT_SIGN_IN_SUCCESS"] = "bc_checkout_sign_in_success";
  AnalyticsTrackingEvent2["CHECKOUT_CONNECT_SCREEN_VISIT"] = "bc_checkout_connect_screen_visit";
  AnalyticsTrackingEvent2["CHECKOUT_CONNECT_OTP_POPUP_OPEN"] = "bc_checkout_connect_otp_popup_open";
  AnalyticsTrackingEvent2["CHECKOUT_CONNECT_OTP_SUBMIT"] = "bc_checkout_connect_otp_submit";
  AnalyticsTrackingEvent2["CHECKOUT_CONNECT_OTP_RESEND"] = "bc_checkout_connect_otp_resend";
  AnalyticsTrackingEvent2["CHECKOUT_CONNECT_OTP_TIMEOUT_RETRY"] = "bc_checkout_connect_otp_timeout_retry";
  AnalyticsTrackingEvent2["CHECKOUT_CONNECT_CREDENTIALS_POPUP_OPEN"] = "bc_checkout_connect_credentials_popup_open";
  AnalyticsTrackingEvent2["CHECKOUT_CONNECT_CREDENTIALS_SUBMIT"] = "bc_checkout_connect_credentials_submit";
  AnalyticsTrackingEvent2["CHECKOUT_CONNECT_CREDENTIALS_TIMEOUT_RETRY"] = "bc_checkout_connect_credentials_timeout_retry";
  AnalyticsTrackingEvent2["CHECKOUT_CONNECT_SUCCESS_SCREEN_VISIT"] = "bc_checkout_connect_success";
  AnalyticsTrackingEvent2["CHECKOUT_CONNECT_SUCCESS_TRACK_ORDER_CLICK"] = "bc_checkout_connect_success_track_order_click";
  AnalyticsTrackingEvent2["CHECKOUT_CONNECT_SUCCESS_CONTINUE_SHOPPING_CLICK"] = "bc_checkout_connect_success_continue_shopping_click";
  AnalyticsTrackingEvent2["CHECKOUT_SUMMARY_SCREEN_VISIT"] = "bc_checkout_summary_visit";
  AnalyticsTrackingEvent2["BUTTON_CLICK"] = "button_click";
  AnalyticsTrackingEvent2["DTC_ADD_ITEM_TO_BAG"] = "dtc_add_item_to_bag";
  AnalyticsTrackingEvent2["DTC_OPEN_BUYBOX"] = "dtc_open_buybox";
  AnalyticsTrackingEvent2["DTC_VIEW_PURCHASE_BENEFITS"] = "dtc_view_purchase_benefits";
  AnalyticsTrackingEvent2["DTC_UPDATE_ITEM_QUANTITY"] = "dtc_update_cart_item_quantity";
  AnalyticsTrackingEvent2["CHECKOUT_GUEST_CHECKOUT_REQUEST_RETURN"] = "bc_checkout_guest_checkout_request_return";
  AnalyticsTrackingEvent2["CHECKOUT_SWITCH_TO_GUEST_CHECKOUT"] = "bc_checkout_switch_to_guest_checkout";
  AnalyticsTrackingEvent2["CONCIERGE_SUGGESTED_PILL_CLICKED"] = "concierge_suggested_pill_clicked";
  AnalyticsTrackingEvent2["CONCIERGE_WIDGET_IMPRESSION"] = "concierge:widget_impression";
  AnalyticsTrackingEvent2["CONCIERGE_WIDGET_SESSION_START"] = "concierge:widget_session_start";
  AnalyticsTrackingEvent2["CONCIERGE_CONVERSATION_ACCESS_POINT"] = "concierge:conversation_access_point";
  AnalyticsTrackingEvent2["CONCIERGE_PAGE_CONTEXT"] = "concierge:page_context";
  AnalyticsTrackingEvent2["CONCIERGE_PRODUCT_CLICK"] = "concierge:product_click";
  return AnalyticsTrackingEvent2;
})(AnalyticsTrackingEvent || {});
export {
  AnalyticsTrackingEvent
};
//# sourceMappingURL=events.js.map
